import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { spacing, colors, typography } = THEME;

export const styleSheet = StyleSheet.create({
	page: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
		padding: spacing.lg,
	},
	pageHeader: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	pageTitle: {
		fontFamily: typography.fontFamilies.sora,
		fontSize: typography.fontSizes.xl,
		fontWeight: typography.fontWeights.bold,
		color: colors.text.main,
		margin: 0,
	},
	pageSubtitle: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
	},
	notAuthorized: {
		padding: spacing.xl,
		textAlign: 'center',
		color: colors.text.light,
	},
});
